/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { RubrosMSL } from './rubrosMSL';

export interface ObtenerDetallePagoFacilitoMS { 
    cedulaRuc?: string;
    codigoResultado?: string;
    direccion?: string;
    fechaTransaccion?: string;
    horaTransaccion?: string;
    mensaje?: string;
    nombre?: string;
    valorTotal?: string;
    comision?: number;
    rubros?: Array<RubrosMSL>;
    secuencialResultadoTransaccion?: number;
}